import React, { useState } from 'react';
import { 
  Modal, Form, Input, Switch, Upload, Button, Row, Col, notification 
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import UserCard from './UserCard';

const EditModal = ({ 
  visible, 
  initialValues = {}, 
  onOk, 
  onCancel,
  isClub = false
}) => {
  const [form] = Form.useForm();
  const [previewData, setPreviewData] = useState(initialValues);
  const [imageData, setImageData] = useState("");
  const [_api,setApi] = notification.useNotification();
  const setNotification=(config)=>{
      _api.open(config);
  }
  // 初始化表单值
  React.useEffect(() => {
      initialValues.t_name = initialValues.name;
    if (visible) {
      const defaults = {
        t_name: initialValues.name,
        ...initialValues
      };
      form.setFieldsValue(defaults);
      setPreviewData(defaults);
    }
  }, [visible, initialValues, form, isClub]);

  const handleValuesChange = (_, allValues) => {
    const newData = {
      ...previewData,
      ...allValues,
      img: imageData || previewData.img,
      tag: isClub ? "社团" : allValues.tag
    };
    setPreviewData(newData);
  };

// 在handleImageChange方法中确保正确处理图片
const handleImageChange = (file) => {
  try{
    const reader = new FileReader();
    reader.onload = (e) => {
      const dataUrl = e.target.result;
      setImageData(dataUrl);
      form.setFieldsValue({ img_b: dataUrl });
      setPreviewData(prev => ({
        ...prev,
        img: dataUrl
      }));
    };
    reader.readAsDataURL(file);
  } catch(e){
    setNotification({
      type:"error",
      message:"错误",
      description:e.message
    })
  }
  return false;
};

  const handleOk = () => {
    try{
      form.validateFields()
      .then(values => {
        console.log(values,"values-EditModal")
        onOk({
          ...values,
          img: ImageData || values.img,
          img_b: imageData || values.img,
          tag: isClub ? "社团" : values.tag
        });
      });
    } catch(e){
      setNotification({
        type:"error",
        message:"错误",
        description:"请检查输入内容"
      })
    }
  };

  return (
    <Modal
      title={isClub ? "编辑社团信息" : "编辑用户信息"}
      visible={visible}
      width={800}
      onOk={handleOk}
      onCancel={onCancel}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          确定
        </Button>
      ]}
    >
      {setApi}
      <Row gutter={24}>
        <Col span={12}>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={handleValuesChange}
          >
            {isClub ? (
              <>
                <Form.Item 
                  name="club" 
                  label="社团ID"
                  rules={[{ required: true, message: '请输入社团ID' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item 
                  name="name" 
                  label="社团名称"
                  rules={[{ required: true, message: '请输入社团名称' }]}
                >
                  <Input />
                </Form.Item>
              </>
            ) : (
              <>
                <Form.Item 
                  name="tag" 
                  label="标签"
                  initialValue="团员"
                >
                  <Input />
                </Form.Item>
                <Form.Item 
                  name="name" 
                  label="名称"
                  rules={[{ required: true, message: '请输入名称' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item 
                  name="level" 
                  label="段位"
                >
                  <Input placeholder="请输入用户段位" />
                </Form.Item>
              </>
            )}
            
            <Form.Item name="text" label={isClub ? "描述" : "简介"}>
              <Input.TextArea />
            </Form.Item>
            
            <Form.Item name="show" label="是否展示" valuePropName="checked">
              <Switch />
            </Form.Item>
            
            <Form.Item name="img" label={isClub ? "社团图片" : "头像"}>
              <Upload
                accept="image/*"
                beforeUpload={handleImageChange}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>
                  {isClub ? "上传社团图片" : "上传头像"}
                </Button>
              </Upload>
            </Form.Item>
          </Form>
        </Col>
        
        <Col span={12}>
          <div style={{ padding: '0 20px' }}>
            <h3>预览效果</h3>
            <UserCard 
              user={{
                ...previewData,
                tag: isClub ? "社团" : (previewData.tag || "团员"),
                text: isClub ? (previewData.subtitle || previewData.text) : previewData.text,
                img:previewData.img,
              }} 
            />
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default EditModal;
